import { WelcomeMessagesFlowInterface } from '@central-products/welcome-messages-flow-interface';
import InterfaceAccountActions, {
  ACCOUNT_ACTION_IDS,
  ActionsRequestedPayload,
} from '@central-products/interface-account-actions';
import { HandlerPayload } from './typings';
import canShowWelcomeMessage from './canShowWelcomeMessage';

export default ({ transport }: HandlerPayload) => {
  const accountActionsProxy = transport.get<InterfaceAccountActions>(InterfaceAccountActions);
  const wmFlowProxy = transport.get<WelcomeMessagesFlowInterface>(WelcomeMessagesFlowInterface);

  accountActionsProxy.onActionRequested((action: ActionsRequestedPayload) => {
    if (action.actionId === ACCOUNT_ACTION_IDS.WELCOME_MESSAGES_OPEN && canShowWelcomeMessage()) {
      wmFlowProxy.start(action);
    }
  });
};
